namespace $.$$ {
	export class $shm_hitalama_map_widget_float_text_md extends $.$shm_hitalama_map_widget_float_text_md {
		
		@ $mol_mem
		text() {
			const text = this.widget().text()
			if( !this.widget().title().startsWith( 'Benchmark analysis ' ) ) return text
			if( this.widget().title().startsWith( 'Benchmark analysis events ' ) ) return text
			return text.replaceAll( '{{client_id}}', this.map().Journal_snapshots()?.remote()?.client_id() ?? '' )
		}
		
	}
}
